import { render, staticRenderFns } from "./bath-tub.vue?vue&type=template&id=33aa2e74&scoped=true"
import script from "./bath-tub.vue?vue&type=script&lang=js"
export * from "./bath-tub.vue?vue&type=script&lang=js"
import style0 from "./bath-tub.vue?vue&type=style&index=0&id=33aa2e74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33aa2e74",
  null
  
)

export default component.exports